import React from "react";
import { Helmet } from "react-helmet";
import AudioRecorder from "../components/features/audio-recorder";
import ProceduresScheduler from "../components/scheduler";

const Scheduler = () => {
  
  return (
    <>
      <Helmet>
        <title>Scheduler</title>
      </Helmet>
      {/* <ProceduresScheduler /> */}
    </>
  );
};

export default Scheduler;
